import { Component } from '@angular/core';
import { SkeletonComponent } from '../../../shared/skeleton/skeleton.component';

@Component({
  selector: 'app-sync-item-logs-table-skeleton',
  templateUrl: './sync-item-logs-table-skeleton.component.html',
  styleUrls: ['./sync-item-logs-table-skeleton.component.scss'],
  imports: [SkeletonComponent],
})
export class SyncItemLogsTableSkeletonComponent {
  readonly rows = [1, 2, 3, 4, 5, 6];
  readonly cols = [1, 2, 3, 4];
}